import React, { useEffect, useState } from 'react'
import { customStyles } from '../../../HelperFunctions';
import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import Cookies from "js-cookie";
import InputTextJSX from '../../Masters/EmployeeMaster/CountryStateCity/InputTextJSX';
import InputDateJSX from '../../Masters/Transaction/Forwarding/Dynamic/InputDateJSX';
import { getBillingJobOrder, getBillingJobOrderDetails } from '../../../Redux/action/Account/BillingAction';
import { toast } from 'react-toastify';
import axios from 'axios';
import { adminMainUrl } from '../../../Config';

const AddBilling = ({ billtype }) => {
    const token = Cookies.get("token");
    const user_id = Cookies.get("flexichain_user_id");
    const { b64job_id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //check if already exist with job order

    const [jobOrderOptions, setJobOrderOptions] = useState([]);
    const [disableJobOrderField, setDisableJobOrderField] = useState(false);

    const generateInvoiceSeries = () => {
        const year = new Date().getFullYear().toString().slice(-2); // "26"

        // Generate an 8-digit unique number
        const unique = (
            Date.now().toString().slice(-5) +
            Math.floor(Math.random() * 1000).toString().padStart(3, "0")
        );

        return `INV/${year}/${unique}`;
    };

    useEffect(() => {
        dispatch(getBillingJobOrder(token, user_id))
    }, []);


    const {
        loadingBillingJobOrder,
        BillingJobOrder,
        BillingJobOrderError,

        loadingBillingJobOrderDetail,
        BillingJobOrderDetail,
        BillingJobOrderDetailError
    } = useSelector(state => state.BillingReducer);


    useEffect(() => {
        if (BillingJobOrder) {
            let jobordersarr = BillingJobOrder.map(v => { return { value: v.id, label: v.job_order_unique_no } });
            setJobOrderOptions(jobordersarr);
        } else {
            setJobOrderOptions([]);
        }
    }, [BillingJobOrder])




    const payment_terms_option = [
        '1 Week',
        '15 Days',
        '1 Month',
        'Quarterly',
        'Half Yearly', 'Yearly'
    ]

    const tax_type_options = [
        { id: 1, val: "GST", percent: 18, cgst: 9, sgst: 9, igst: 18 },
        { id: 2, val: "TDS", percent: 20, cgst: 9, sgst: 9, igst: 18 },
    ];
    const round2 = (num) => Number(Number(num || 0).toFixed(2));

    const [isSubmitting, setIsSubmitting] = useState(false);
    const formik = useFormik({
        initialValues: {
            invoice_series: "",
            invoice_number: "",
            invoice_date: "",
            due_date: "",
            payment_terms: "",
            tax_type: "",
            reference_no: "",
            gross_amount: "0",
            discount_percent: "0",
            discount_amount: "0",
            taxable_amount: "0",
            output_gst_percent: "0",
            output_gst_amount: "0",
            round_off_amount: "0",
            net_receivable_amount: "0",
            charges: [
                {
                    charge_name: "",
                    income_ledger: "",
                    sac: "",
                    qty: 0,
                    unit: 0,
                    rate: 0,
                    amount: 0,
                    gst_tds_percent: 0,
                    gst_tds_amount: 0,
                    cgst_percent: 0,
                    cgst_amount: 0,
                    sgst_percent: 0,
                    sgst_amount: 0,
                    igst_percent: 0,
                    igst_amount: 0,
                    total_amount: 0,
                }
            ],
        },
        onSubmit: (values, { resetForm }) => {
            values.created_by = user_id;
            values.admin_id = 1;
            try {
                axios.post(`${adminMainUrl}/api/account/billing/create`,
                    values, // The request payload
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': Cookies.get('token'), // Assuming the token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        }
                    }
                ).then(response => {
                    if (response.status === 200) { // Check if the response is OK
                        toast.success(response.data?.msg);
                        setIsSubmitting(false);
                        resetForm();
                        formik.values.job_order_id = ""
                    } else {
                        toast.error(response.data?.msg);
                    }
                }).catch(error => {
                    setIsSubmitting(false);
                    if (error.response) {
                        toast.error(error.response.data?.msg || "An error occurred.");
                        console.error('Some error occured:', error.response.data?.message);
                    } else {
                        toast.error("Network error or server is unreachable.");
                        console.error('Network error:', error);
                    }
                });
            } catch (error) {
                setIsSubmitting(false);
                console.error('Network error:', error);
            }
        }
    });

    const handleStatusSubmit = (status) => {
        formik.setFieldValue("current_status", status);
        formik.submitForm();
    };

    useEffect(() => {
        formik.setFieldValue("invoice_series", generateInvoiceSeries());
    }, []);

    let config = {
        headers: {
            'auth-token': token,
            'user_id': user_id,
            'Content-Type': 'application/json',
        }
    };

    useEffect(() => {
        try {
            if (b64job_id) {
                let job_id = atob(b64job_id);
                setDisableJobOrderField(true);
                if (job_id) {
                    formik.setFieldValue("job_order_id", job_id);
                };
                axios.post(`${adminMainUrl}/api/account/billing/check-job-order`, { job_order_id: job_id }, config)
                    .then(response => {
                        if (response.status == 201) {
                            console.log(response);
                            navigate(`/flexichain/edit-billing/${btoa(response.data.data.id)}`)
                        } else if (response.status == 200) {
                            //eat kitkat do nothing.
                        }
                    })
            } else {
                setDisableJobOrderField(false);
            }
        } catch (error) {
            console.log(error);
        }
    }, [b64job_id]);

    useEffect(() => {
        if (formik.values.job_order_id) {
            dispatch(getBillingJobOrderDetails(token, user_id, formik.values.job_order_id));
        }
    }, [formik.values.job_order_id])

    const calculateInvoice = (charges, taxType = formik.values.tax_type) => {
        let grossAmount = 0;
        let totalTaxAmount = 0;

        charges.forEach((item) => {
            const qty = Number(item.qty || 0);
            const rate = Number(item.rate || 0);

            item.amount = round2(qty * rate);

            item.cgst_amount = round2(
                item.amount * Number(item.cgst_percent || 0) / 100
            );

            item.sgst_amount = round2(
                item.amount * Number(item.sgst_percent || 0) / 100
            );

            item.igst_amount = round2(
                item.amount * Number(item.igst_percent || 0) / 100
            );

            item.total_amount = round2(
                item.amount +
                item.cgst_amount +
                item.sgst_amount +
                item.igst_amount
            );

            grossAmount += item.amount;

            totalTaxAmount +=
                item.cgst_amount +
                item.sgst_amount +
                item.igst_amount;
        });

        grossAmount = round2(grossAmount);
        totalTaxAmount = round2(totalTaxAmount);

        const discountPercent = 0;
        const discountAmount = 0;
        const roundOff = 0;

        const netReceivable = round2(
            grossAmount +
            totalTaxAmount -
            discountAmount +
            roundOff
        );

        formik.setValues({
            ...formik.values,
            charges,
            tax_type: taxType,
            gross_amount: grossAmount,
            discount_percent: discountPercent,
            discount_amount: discountAmount,
            taxable_amount: totalTaxAmount,

            output_gst_percent:
                charges.length
                    ? round2(
                        Number(charges[0].cgst_percent || 0) +
                        Number(charges[0].sgst_percent || 0) +
                        Number(charges[0].igst_percent || 0)
                    )
                    : 0,

            output_gst_amount: totalTaxAmount,
            round_off_amount: roundOff,
            net_receivable_amount: netReceivable,
        });
    };

    const handleLineItemChange = (index, field, value) => {
        const charges = [...formik.values.charges];

        charges[index][field] = value;

        calculateInvoice(charges);
    };


    const handleDeleteLine = (index) => {

        if (formik.values.charges.length === 1) return;

        const charges = formik.values.charges.filter(
            (_, i) => i !== index
        );

        calculateInvoice(charges);
    };


    const handleAddLine = () => {

        const tax = tax_type_options.find(
            x => x.val === formik.values.tax_type
        );

        const charges = [
            ...formik.values.charges,
            {
                charge_name: "",
                income_ledger: "",
                sac: "",
                qty: 0,
                unit: 0,
                rate: 0,

                amount: 0,

                cgst_percent: tax ? tax.cgst : 0,
                cgst_amount: 0,

                sgst_percent: tax ? tax.sgst : 0,
                sgst_amount: 0,

                igst_percent: tax ? tax.igst : 0,
                igst_amount: 0,

                total_amount: 0,
            },
        ];

        calculateInvoice(charges);
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <h6>Add Sales Billing</h6>
                        </div>
                        {/* Filter */}
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 my-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Job Order No.
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <Select
                                                className='custom-selector'
                                                options={jobOrderOptions}
                                                styles={customStyles}
                                                name="job_order_id"
                                                onChange={option => {
                                                    formik.setFieldValue('job_order_id', option.value);
                                                }}
                                                value={jobOrderOptions.find(option => option.value == formik.values.job_order_id || null)}
                                                isDisabled={disableJobOrderField}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {formik.values.job_order_id && BillingJobOrderDetail.id && <div className="table-responsive mt-3">
                                    <table className="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <th width="30%">Customer</th>
                                                <td>{BillingJobOrderDetail.customer_details?.name}</td>
                                            </tr>

                                            <tr>
                                                <th>Email</th>
                                                <td>{BillingJobOrderDetail.customer_details?.email}</td>
                                            </tr>

                                            <tr>
                                                <th>Customer Branch</th>
                                                <td>{BillingJobOrderDetail.customer_branch_details?.branch_name}</td>
                                            </tr>

                                            <tr>
                                                <th>Transport Mode</th>
                                                <td>{BillingJobOrderDetail.trans_mode}</td>
                                            </tr>

                                            <tr>
                                                <th>Transport Type</th>
                                                <td>{BillingJobOrderDetail.trans_type}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>}

                                <hr />

                                <h3>Invoice Details</h3>

                                <div className="col-md-6 mt-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Invoice Series
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input type="text"
                                                className="form-control form-control-sm"
                                                name="invoice_series"
                                                onChange={formik.handleChange}
                                                value={formik.values.invoice_series}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <InputTextJSX labelText={"Invoice Number"} nameValue="invoice_number" value={formik.values.invoice_number} onChange={formik.handleChange} splithalf={false} maxLength={250} />
                                <InputDateJSX labelText={"Invoice Date"} nameValue="invoice_date" value={formik.values.invoice_date} onChange={formik.handleChange} />
                                <InputDateJSX labelText={"Due Date"} nameValue="due_date" value={formik.values.due_date} onChange={formik.handleChange} />


                                <div className="col-md-6 mt-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Payment Terms
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <select name="payment_terms"
                                                className="form-control form-control-sm"
                                                onChange={formik.handleChange}
                                                value={formik.values.payment_terms}
                                            >
                                                <option value="">-Select a value-</option>
                                                {payment_terms_option.map((v, i) => {
                                                    return <option value={v} key={i}>{v}</option>
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Tax Type
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <select
                                                name="tax_type"
                                                className="form-control form-control-sm"
                                                value={formik.values.tax_type}
                                                onChange={(e) => {

                                                    const tax = tax_type_options.find(
                                                        x => x.val === e.target.value
                                                    );

                                                    const charges = [...formik.values.charges];

                                                    charges.forEach(item => {

                                                        item.cgst_percent = tax ? tax.cgst : 0;
                                                        item.sgst_percent = tax ? tax.sgst : 0;
                                                        item.igst_percent = tax ? tax.igst : 0;

                                                    });

                                                    // formik.setFieldValue("tax_type", e.target.value);

                                                    calculateInvoice(charges, e.target.value);
                                                }}
                                            >
                                                <option value="">-Select-</option>

                                                {tax_type_options.map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.val}
                                                    >
                                                        {item.val}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 mt-2">
                                    <div className='ms-2'>
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Reference Number
                                        </label>
                                        <div className="icon-forms mb-3 mb-sm-0">
                                            <input type="text"
                                                className="form-control form-control-sm"
                                                name="reference_no"
                                                onChange={formik.handleChange}
                                                value={formik.values.reference_no}
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div className="table-responsive">
                                    <div className="mt-2" style={{ float: "right" }}>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={handleAddLine}
                                        >
                                            <i className="fa fa-plus me-1"></i>
                                            Add Row
                                        </button>
                                    </div>

                                    <table className="table table-bordered align-middle">

                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Charge name</th>
                                                <th>Income Ledger</th>
                                                <th>SAC</th>
                                                <th>Quantity</th>
                                                <th>Unit</th>
                                                <th>Rate</th>
                                                <th>Amount</th>
                                                <th>CGST (%)</th>
                                                <th>CGST Amount</th>
                                                <th>SGST (%)</th>
                                                <th>SGST Amount</th>
                                                <th>IGST (%)</th>
                                                <th>IGST Amount</th>
                                                <th>Total</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {formik.values.charges.map(
                                                (item, index) => (

                                                    <tr key={index}>

                                                        <td>
                                                            {index + 1}
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.charge_name}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "charge_name",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.income_ledger}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "income_ledger",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.sac}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "sac",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.qty}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "qty",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={item.unit}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "unit",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.rate}
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "rate",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.amount}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.cgst_percent}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "cgst_percent",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.cgst_amount}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "cgst_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.sgst_percent}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "sgst_percent",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.sgst_amount}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "sgst_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.igst_percent}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "igst_percent",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.igst_amount}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "igst_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={item.total_amount}
                                                                disabled
                                                                onChange={(e) =>
                                                                    handleLineItemChange(
                                                                        index,
                                                                        "total_amount",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>


                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDeleteLine(index)}
                                                                disabled={formik.values.charges.length === 1}
                                                            >
                                                                <i className="fa fa-trash btn-red"></i>
                                                            </button>
                                                        </td>

                                                    </tr>
                                                )
                                            )}

                                        </tbody>

                                    </table>
                                    <div className="row">
                                        <div className="d-flex justify-content-end">
                                            <h5>
                                                Total Amount :
                                                ₹ {Number(formik.values.net_receivable_amount || 0).toLocaleString()}
                                            </h5>
                                        </div>
                                    </div>
                                </div>

                                <hr />

                                <h6 className="mb-3">Receivable Summary</h6>

                                <div className="border rounded p-3 bg-light">
                                    <div className="row mb-2">
                                        <div className="col-md-6 fw-semibold">Gross Amount</div>
                                        <div className="col-md-6 text-end">
                                            ₹ {Number(formik.values.gross_amount || 0).toLocaleString()}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-6 fw-semibold">
                                            Discount ({formik.values.discount_percent || 0}%)
                                        </div>
                                        <div className="col-md-6 text-end">
                                            ₹ {Number(formik.values.discount_amount || 0).toLocaleString()}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-6 fw-semibold">Taxable Amount</div>
                                        <div className="col-md-6 text-end">
                                            ₹ {Number(formik.values.taxable_amount || 0).toLocaleString()}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-6 fw-semibold">
                                            Output GST ({formik.values.output_gst_percent || 0}%)
                                        </div>
                                        <div className="col-md-6 text-end">
                                            ₹ {Number(formik.values.output_gst_amount || 0).toLocaleString()}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-6 fw-semibold">Round Off</div>
                                        <div className="col-md-6 text-end">
                                            ₹ {Number(formik.values.round_off_amount || 0).toLocaleString()}
                                        </div>
                                    </div>

                                    <hr className="my-2" />

                                    <div className="row">
                                        <div className="col-md-6 fw-bold fs-6">Net Receivable</div>
                                        <div className="col-md-6 text-end fw-bold fs-6 text-primary">
                                            ₹ {Number(formik.values.net_receivable_amount || 0).toLocaleString()}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="d-flex flex-wrap gap-2 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleStatusSubmit("SAVE_DRAFT")}
                                    disabled={isSubmitting}
                                >
                                    Save Draft
                                </button>

                                {billtype == "sales" && <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleStatusSubmit("SUBMIT_TO_ACCOUNTS")}
                                    disabled={isSubmitting}
                                >
                                    Submit to Account
                                </button>}

                                {/*<button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleStatusSubmit("APPROVE")}
                                    disabled={isSubmitting}
                                >
                                    Approve
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => handleStatusSubmit("POST_INVOICE")}
                                    disabled={isSubmitting}
                                >
                                    Post Invoice
                                </button> */}

                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => formik.resetForm()}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>


                    </div>
                </div>
            </div >
        </div >
    )
}

export default AddBilling